(() => {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-filters]');
    const cards = [...root.querySelectorAll('[data-tent-card]')];
    const status = root.querySelector('[data-result-status]');
    const empty = root.querySelector('[data-empty]');
    if (!form || !cards.length) return;
    const filter = () => {
      const capacity = form.elements.capacity.value;
      const poles = form.elements.poles.value;
      const maxPrice = Number(form.elements.budget.value);
      const availableOnly = form.elements.available.checked;
      let count = 0;
      for (const card of cards) {
        const matches = (!capacity || card.dataset.capacity === capacity)
          && (!poles || card.dataset.poles === poles)
          && (!maxPrice || Number(card.dataset.price) <= maxPrice)
          && (!availableOnly || card.dataset.available === 'true');
        card.hidden = !matches;
        if (matches) count++;
      }
      status.textContent = `${count} of ${cards.length} selected tents match your choices.`;
      empty.hidden = count !== 0;
    };
    form.addEventListener('change', filter);
    form.addEventListener('submit', event => event.preventDefault());
    root.querySelector('[data-reset]').addEventListener('click', () => {
      form.reset();
      filter();
    });
    form.hidden = false;
    filter();
  }
  const start = () => document.querySelectorAll('[data-cwc-tent-finder]').forEach(init);
  start();
  document.addEventListener('shopify:section:load', start);
})();
